<div class="billing-page">
  <p class="page-title__sub">Finishing up…</p>
</div>
